import { render } from "./Twofa.vue?vue&type=template&id=b7a81dc4&scoped=true"
import script from "./Twofa.vue?vue&type=script&lang=js"
export * from "./Twofa.vue?vue&type=script&lang=js"

import "./Twofa.vue?vue&type=style&index=0&id=b7a81dc4&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a81dc4"]])

export default __exports__